<template>
  <div :class="large && status ? 'reg-large-loading' : ''">
    <v-fade-transition :hide-on-leave="true">
      <slot v-if="status" name="loading">
        <v-container class="align">
          <v-progress-circular :width="2" :color="color" :size="large ? 30 : 15" indeterminate />
        </v-container>
      </slot>
    </v-fade-transition>
    <v-fade-transition :hide-on-leave="true">
      <div v-show="status === false"
           class="reg-loading-content">
        <slot />
      </div>
    </v-fade-transition>
  </div>
</template>

<script>
export default {
  props: {
    when: {
      type: Boolean,
      default: false
    },
    loader: {
      type: [String, Array],
      default: ''
    },
    color: {
      type: String,
      default: 'primary'
    },
    large: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: false
    }
  },
  computed: {
    isLoading() {
      const store = this.$store
      if (!store) {
        throw new Error('Vuex not initialized.')
      }
      return store.getters.isLoading
    },
    anyLoading() {
      const store = this.$store
      if (!store) {
        throw new Error('Vuex not initialized.')
      }
      return store.getters.anyLoading
    },
    status() {
      if (this.when) {
        return this.when
      }
      if (this.loader) {
        return this.isLoading(this.loader)
      }
      return false
    }
  }
}
</script>

<style lang="scss">
.reg-large-loading {
  text-align: center;
  margin: 20px;
}
</style>
